import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=e84201e4&"
import script from "./Confetti.vue?vue&type=script&lang=js&"
export * from "./Confetti.vue?vue&type=script&lang=js&"
import style0 from "./Confetti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports